import { EntityStatusBadge } from '@frontend/components/badge';
import { TransactionStateName } from '@frontend/transaction/types';
import React from 'react';

import useTransactionStateBadge from './transaction-state-badge.controller';

const ID = 'transaction-state-badge';
export interface TransactionStateBadgeProps {
    state: TransactionStateName;
}

export const TransactionStateBadge = (props: TransactionStateBadgeProps) => {
    const viewProps = useTransactionStateBadge(props);
    return (
        <EntityStatusBadge
            id={ID}
            label={viewProps.displayName}
            variant={viewProps.variant}
        />
    );
};
